import Vue from 'vue'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'

import Home from '@/pages/Home'
import Index from '@/pages/Index'
import Search from '@/pages/Search/Search'
import Preview from '@/pages/Preview'
import NotFound from '@/pages/404'
import Archive from '@/pages/Archive'

Vue.use(VueHead)
Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: Home,
    name: 'home'
  },
  {
    path: '/search/:searchText',
    component: Search,
    name: 'search'
  },
  {
    path: '/preview',
    component: Preview,
    name: 'preview'
  },
  {
    path: '/news-archive/:term',
    component: Archive,
    name: 'News Archive',
    meta: {
      taxonomy: 'news_cat',
    }
  },
  {
    path: '/streamers-archive/:term',
    component: Archive,
    name: 'Streams Archive',
    meta: {
      taxonomy: 'streamer',
    }
  },
  {
    path: '/:postSlug',
    name: 'Index',
    component: Index,
    props: true,
  },
  {
    path: '*',
    name: '404',
    component: NotFound,
    meta: {
      title: '404 - Not Found',
      metaTags: [
        {
          name: 'description',
          content: 'You are lost!'
        },
        {
          property: 'og:description',
          content: 'You are lost!'
        }
      ]
    },
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  base: '',
  // Prevents window from scrolling back to top
  // when navigating between components/views
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

function loadView(view) {
  let viewName = view === 'GamePaid' ? 'GameFree' : view
  return () => import(/* webpackChunkName: "view-[request]" */ `@/pages/${viewName}/${viewName}.vue`)
}

// Add custom routes components
let custom_rc = []

if (wpvue_script_data_params.data.post_types) {
  for (let key in wpvue_script_data_params.data.post_types) {
    let type = key
    var item_comp = '',
      slug_arr = type.split('_')
    slug_arr.map(function (part) {
      item_comp += part.charAt(0).toUpperCase() + part.slice(1)
    })
    custom_rc.push({
      path: `/${type}/:postSlug`,
      name: item_comp,
      component: loadView(item_comp),
    })
  };

  if (custom_rc.length != 0) router.addRoutes(custom_rc)
}

// Add dynamic post routes
const d_routes = wpvue_script_data_params.data.routes
if (d_routes) {
  if (d_routes != null || d_routes.length != 0) {
    let routes_posts = []
    d_routes.map(function (route) {
      if (route.hasOwnProperty('modified_base')) {
        routes_posts.push({
          path: `/${route.modified_base}/:postSlug`,
          name: route.name,
          component: function (resolve) {
            require([`@/pages/${route.component_base}/${route.component_base}.vue`], resolve)
          }
        })
      } else {
        routes_posts.push(route)
      }
    })
    router.addRoutes(routes_posts)
  }
};



// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  const routes_meta = wpvue_script_data_params.data.routes_meta
  const route_slug = (to.params.postSlug) ? to.params.postSlug : wpvue_script_data_params.frontpage_slug

  // Reset localstorage
  if (route_slug != localStorage.getItem("storedPageName")) {
    //localStorage.clear()
    localStorage.removeItem('storedPageName')
  }

  let route_meta = to.meta
  if (route_slug) {
    route_meta = (routes_meta && routes_meta[route_slug]) ? routes_meta[route_slug] : route_meta
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[vue-router-head-controlled]')).map(el => el.parentNode.removeChild(el))

  if (!route_meta) return next()

  if (route_meta.title) document.title = unescapeHtml(route_meta.title)

  // Add scripts into actual elements in the head.
  if (route_meta.scripts) {
    route_meta.scripts.map(tagDef => {
      const script = document.createElement('script')
      Object.keys(tagDef).forEach(key => {
        if (key == 'body') {
          script.appendChild(document.createTextNode(tagDef[key]))
        } else {
          script.setAttribute(key, tagDef[key])
        }
      })
      script.setAttribute('vue-router-head-controlled', '')

      let vueapp = document.getElementById('app')

      if (!tagDef.hasOwnProperty('placed') || tagDef['placed'] == 'header') {
        if (script) {
          document.head.appendChild(script)
        }
      } else if (tagDef['placed'] == 'body_top') {
        if (vueapp && script) {
          vueapp.insertAdjacentElement('beforebegin', script)
        }
      } else if (tagDef['placed'] == 'body_bottom') {
        if (vueapp && script) {
          vueapp.insertAdjacentElement('afterend', script)
        }
      } else if (tagDef['placed'] == 'footer') {
        let body = document.querySelector('body')
        if (body && script) {
          body.insertAdjacentElement('beforeend', script)
        }
      } else { }

    })
  }


  // Add link into actual elements in the head.
  if (route_meta.scripts) {
    route_meta.styles.map(tagDef => {
      const link = document.createElement('link')
      Object.keys(tagDef).forEach(key => {
        link.setAttribute(key, tagDef[key])
      })
      link.setAttribute('vue-router-head-controlled', '')
      return link
    }).forEach(link => document.head.appendChild(link))
  }

  // Skip rendering meta tags if there are none.
  if (!route_meta.metaTags) return next()

  // Turn the meta tag definitions into actual elements in the head.
  route_meta.metaTags.forEach(tagDef => {
  })

  next()
})

function unescapeHtml(text) {
  var specialchars = [
    ['–', '&ndash;'],
    ['—', '&mdash;'],
    ['·', '&middot;'],
    ['•', '&bull;'],
    ['⋆', '&#8902;'],
    ['«', '&laquo;'],
    ['»', '&raquo;'],
    ['<', '&lt;'],
    ['<', '&#060;'],
    ['>', '&gt;'],
    ['>', '&#062;'],
    ["'", '&#039;'],
    ['"', '&quot;'],
    ['"', '&#x22;'],
    ['"', '&#034;'],
    ['&', '&amp;'],
    ['&', '&#038;'],
    ['&', '&#x26;'],
  ]

  if (!text) {
    return text
  }

  var unescapedString = text

  // For each of the special characters,
  var len = specialchars.length
  for (var x = 0;x < len;x++) {
    // Replace all instances of the special character with its entity.
    unescapedString = unescapedString.replace(
      new RegExp(specialchars[x][1], 'g'),
      specialchars[x][0]
    )
  }

  return unescapedString
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js